<template>
  <div id="UnitDetail">
    <jw-navigation>
      <banner></banner>
      <div class="page-content">
        <div style="display: flex;flex-direction: row;justify-content: start;align-items: center;">
          <img :src="memberUnit.logo" style="width: 60px;height: 60px;border-radius: 5px;margin-right: 5px;">
          <div>
            <h2 style="text-align: left;">{{memberUnit.unit_name}}</h2>
            <div style="display: flex;flex-direction: row;">
              <h4 style="margin-bottom: 5px;">负责人：</h4><p>{{memberUnit.link_man}}</p>
            </div>
          </div>
        </div>
        <div style="margin: 5px 0;padding:5px;">
          <h4 style="border-bottom: 1px solid #e8eaec;margin-bottom: 5px;">简介：</h4>
          <p v-html="memberUnit.introduction"></p>
        </div>
        <div style="margin: 5px 0;padding:5px;">
          <h4 style="border-bottom: 1px solid #e8eaec;margin-bottom: 5px;">会员单位地址：</h4>
          <p>{{memberUnit.address}}</p>
        </div>
      </div>
    </jw-navigation>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner.vue";
import {getMemberUnitList} from "@/request/web/members";
export default {
  name: "UnitDetail",
  // 注册组件
  components: {
    Banner
  },
  // 属性
  props: {},
  // 页面数据
  data() {
    return {
      memberUnit: {
        unit_name: '',
        link_man: '',
        introduction: '',
        address: '',
      },
      page: {
        pageIndex: 1,
        pageSize: 1
      },
      filter: {
        unit_id: ''
      }
    }
  },
  created() {
    this.filter.unit_id = this.$route.params.unitId
    this.onGetMemberUnitList()
  },
  mounted() {
  },
  // 观察者
  watch: {},
  // 计算属性
  computed: {},
  methods: {
    // 获取会员单位列表
    onGetMemberUnitList() {
      getMemberUnitList({
        ...this.page,
        filter: this.filter
      }).then(res=> {
        this.memberUnit = res.data.data.list[0]
      })
    },
  }
}
</script>

<style scoped>

</style>
